import { render, staticRenderFns } from "./ImportantLinksModal.vue?vue&type=template&id=6e2e3498&scoped=true&"
import script from "./ImportantLinksModal.vue?vue&type=script&lang=js&"
export * from "./ImportantLinksModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportantLinksModal.vue?vue&type=style&index=0&id=6e2e3498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2e3498",
  null
  
)

export default component.exports